enum EcommerceShoppingListDataSourceEnum {
	default = 'default',
	disabled = 'disabled',
	shoppingListApi = 'ShoppingListApi',
	chinaShoppingListApi = 'ChinaShoppingListApi',
	iows = 'IOWS',
	mvecom = 'MvEcom',
	iksa = 'IKSA'
}

export default EcommerceShoppingListDataSourceEnum;
